(function () {
  function getVariantId() {
    // 1) URL ?variant=
    const url = new URL(window.location.href);
    const v = url.searchParams.get('variant');
    if (v) return v;

    // 2) Input hidden id (souvent mis à jour)
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;

    return null;
  }

  function getEntryFromMap(variantId, mapWrap) {
    if (!variantId || !mapWrap) return null;
    const node = mapWrap.querySelector(`[data-variant-id="${CSS.escape(String(variantId))}"]`);
    if (!node) return null;
    return {
      type: node.getAttribute('data-type'),
      src: node.getAttribute('data-src'),
      alt: node.getAttribute('data-alt') || ''
    };
  }

  function reset(img, vid) {
    if (!img || !vid) return;
    img.style.display = 'none';
    img.removeAttribute('src');
    img.setAttribute('alt', '');

    vid.style.display = 'none';
    try { vid.pause(); } catch (e) {}
    vid.removeAttribute('src');
    try { vid.load(); } catch (e) {}
  }

  function showImage(img, vid, src, alt) {
    reset(img, vid);
    img.src = src;
    img.alt = alt || '';
    img.style.display = 'block';
  }

  function showVideo(img, vid, src) {
    reset(img, vid);
    vid.src = src;
    vid.style.display = 'block';
    try { vid.load(); vid.play().catch(()=>{}); } catch (e) {}
  }

  let lastVariantId = null;

  function tick() {
    // ⚠️ re-query à chaque tick -> marche même si le DOM est remplacé
    const block = document.getElementById('variant-media-block');
    if (!block) return;

    const img = document.getElementById('variant-image');
    const vid = document.getElementById('variant-video');
    const mapWrap = document.getElementById('variant-media-map');

    const productVideo = (block.getAttribute('data-product-video') || '').trim();
    const variantId = getVariantId();

    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    const entry = getEntryFromMap(variantId, mapWrap);

    if (entry && entry.src) {
      if (entry.type === 'image') return showImage(img, vid, entry.src, entry.alt);
      return showVideo(img, vid, entry.src); // video/file
    }

    if (productVideo) return showVideo(img, vid, productVideo);
    reset(img, vid);
  }

  // Boucle légère (fiable même sans events)
  setInterval(tick, 250);

  // Et un tick au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
